import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import _ from 'lodash';

import { NotificationCardVM } from './sm-global-notifications-card/sm-global-notifications-card.component';
import { UserNotificationCenter } from '@Core/models/codegen/configuration.models';

@Component({
    standalone: false,
    selector: 'sm-global-notifications',
    templateUrl: './sm-global-notifications.component.html',
    styleUrls: ['./sm-global-notifications.component.scss']
})
export class SmGlobalNotificationsComponent implements OnInit, OnChanges {
    @Input() settings: UserNotificationCenter;
    @Input() notificationCards: NotificationCardVM[] = [];

    @Output() onClose: EventEmitter<any> = new EventEmitter();
    @Output() onClickLink: EventEmitter<NotificationCardVM> = new EventEmitter();

    public sortedAndFilteredNotifications: NotificationCardVM[] = [];
    public activeTab: string = "Notifications";
    public navbarItems = [
        {
            id: 'Notifications',
            label: 'Notifications (0)'
        },
        {
            id: 'Settings',
            label: 'Settings'
        }
    ];

    constructor() { }

    ngOnInit() {
        this.sortNotifications();
        this.updateNavbarItems();
    }

    // aurora-popover keeps this component alive, so later card loads arrive as input changes.
    ngOnChanges() {
        this.sortNotifications();
    }

    public sortNotifications() {
        this.sortedAndFilteredNotifications = _.orderBy(this.notificationCards, n => n.CreatedOnDate, 'desc');
        this.updateNavbarItems();
    }

    private updateNavbarItems(): void {
        this.navbarItems = [
            {
                id: 'Notifications',
                label: `Notifications (${this.getUnreadNotificationsCount()})`
            },
            {
                id: 'Settings',
                label: 'Settings'
            }
        ];
    }

    onTabClick(tab: string): void {
        this.activeTab = tab;
    }

    onNavbarItemClick(event: CustomEvent): void {
        const selectedId = event?.detail?.item?.id;
        if (selectedId) {
            this.onTabClick(selectedId);
        }
    }

    trackByNotificationId(index: number, notification: NotificationCardVM): string {
        return notification?.Id || `${index}`;
    }

    getUnreadNotificationsCount(): number {
        if (!this.notificationCards)
            return 0;

        return this.notificationCards.filter(notification => notification.IsRead === false).length;
    }
}
